import {
  Input,
  Inject,
  Directive,
  AfterViewInit,
} from 'ng-metadata/core';

/**
 * Scroll the page to show the element
 */
@Directive({
  selector: '[gw-scroll-into-view]',
})
export class ScrollIntoViewDirective implements AfterViewInit {

  constructor(
    @Inject('$element') private $element: ng.IRootElementService,
    @Inject('$timeout') private $timeout: ng.ITimeoutService,
    @Inject('$window') private $window,
  ) {}

  @Input() domain: string 

  ngAfterViewInit() {
    const value = this.$element.attr('gw-scroll-into-view');

    if (value === 'mobile-only' && this.$window.innerHeight > 850) {
      return;
    }

    this.$timeout(
      () => {
        this.$element[0].scrollIntoView({
          behavior: 'smooth',
          block: this.domain && this.domain === 'rushmytravelvisa' ? 'start' : 'center',
          inline: 'start',
        });
      });
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/scroll-into-view.directive.ts